import React, { useState } from 'react';
import { AddRequest } from '../../pages';
import OrderController from '../../controllers/OrderController';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import * as yup from 'yup';
import { phoneRegExp } from '../../utils/utils';

const AddRequestContainer = ({
	closeModal,
	design,
	withMaterial,
	quantity,
}) => {
	const [loading, setLoading] = useState(false);

	const validationSchema = () =>
		yup.object({
			fullname: yup
				.string()
				.required('Full Name is required')
				.test('fullName', 'First and Last name is required', function (value) {
					const names = value ? value.split(' ') : [];
					return names.length > 1 && names[0].length > 1 && names[1].length > 1;
				}),

			mobile: yup
				.string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Phone number is required'),
			email: yup
				.string()
				.trim()
				.email('Enter a valid Email')
				.required('Email Address is required'),
		});

	const onSubmit = async value => {
		setLoading(true);

		const payload = {
			fullname: value.fullname,
			note: value.note,
			quantity,
			withMaterial,
			style: design._id,
			business: design.business._id,
			email: value.email,
			mobile: value.mobile,
		};

		const { status, errorMessage } =
			await OrderController.requestDesign(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	return (
		<AddRequest
			closeModal={closeModal}
			loading={loading}
			design={design}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
		/>
	);
};

export default AddRequestContainer;
